var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.value != null } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-sale-layout", {
                        attrs: {
                          id: "",
                          value: _vm.value,
                          "add-default-option": "",
                          fancy: "",
                          label: _vm.$ct("layout"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onInput($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "print" },
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.confirmText))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }